import SupportInbox from "./SupportInbox/SupportInbox";

const ProblematikatPage = () => {
  return <SupportInbox />;
};

export default ProblematikatPage;
